import Loader from '@repo/ui/loader'

const LoadingScreen = () => {
  return (
    <div className="flex items-center justify-center min-h-44">
      <Loader size="md" />
    </div>
  )
}

export default LoadingScreen
